;(function($) {
    var ArticleContentLayerState = {};

    function addContentLayer() {
        $('body').append('' +
            '<div class="article-content-layer">\n' +
            '  <div class="article-content-layer-close top"><span class="ai ai-remove" aria-hidden="true"></span></div>\n' +
            '  <div class="article-content-layer-content">\n' +
            '    <div id="article-content-layer-content-wrapper"></div>\n' +
            '  </div>\n' +
            '</div>');

        $('body').on('click', '.article-content-layer-close', function() {
            hideArticleContentLayer();
        });

        $('.article-content-layer').on('animationend', function () {
            if($('.article-content-layer').is('.in')){
                $('.article-content-layer').addClass('animationend-in')
            } else {
                $('.article-content-layer').addClass('animationend-out')
                detachArticleContentLayerContent();
                resetArticleContentContext()
            }
            $('.article-content-layer').removeClass('in').removeClass('out');
        })
    }

    function showArticleContentLayer(node, cb) {

        if($('body .article-content-layer').length === 0){
            addContentLayer();
        }

        if(!node) return;

        $(' > *', node).detach().appendTo('#article-content-layer-content-wrapper')

        ArticleContentLayerState = {
            node: node,
            classes: {
                body: $('body').attr('class'),
                header: $('header').attr('class')
            }
        } ;

        $('.article-content-layer').removeClass('out animationend-in animationend-out').addClass('in');
        $('body').addClass('show-article-content-layer');

        $(document).keydown(onKeydownEscape);

        cb && cb()

        window.initOverlayLazyEmbed('.article-content-layer .embed-responsive > iframe[data-lazyembed-overlay="video"]')
    }

    function onKeydownEscape(event) {
        if (event.key == "Escape" || event.key == "Esc") {
            hideArticleContentLayer();
        }
    }

    function hideArticleContentLayer() {
        $('.article-content-layer').removeClass('in animationend-in animationend-out').addClass('out');
        // stop the video player so that no video is played if the content layer is closed
        $('.article-content-layer .articleDetailVideoHolder video').each(function() {
            $(this).get(0).pause();
        })
        $('.article-gallery-detail-media .articleDetailVideoHolder .embed-responsive').each(function () {
            console.log(this);
            const iframe = $(this).find('iframe').get(0);
            const lazyembed = $(this).find('.lazyembed').get(0);
            const src = $(iframe).attr('src');

            iframe.contentWindow.postMessage(JSON.stringify(
                { event: 'command', func: 'pauseVideo' }), 'https://www.youtube.com');

            $(iframe).attr('src', null);
            $(iframe).attr('data-src', src);

            $(iframe).detach().appendTo(this);
            $(lazyembed).remove();
        });

        $(document).unbind('keydown', onKeydownEscape);
    }

    function resetArticleContentContext() {
        Object.keys(ArticleContentLayerState.classes).forEach(function(selector) {
            $(selector).attr('class', ArticleContentLayerState.classes[selector]);
        });
    }

    function detachArticleContentLayerContent() {
        $('#article-content-layer-content-wrapper > *').detach().appendTo(ArticleContentLayerState.node);
    }


    $.fn.articleContentLayer = function(action, cb) {

        switch (action) {
            case 'show':
                showArticleContentLayer($(this).get(0), cb);
                break
            case 'hide':
                hideArticleContentLayer();
                break
            default:
                break
        }

        return this;
    }
})(jQuery);
